// Generated by purs version 0.15.16
import * as API_Account from "../API.Account/index.js";
import * as API_FormType from "../API.FormType/index.js";
import * as App_Step from "../App.Step/index.js";
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as GraphQL_Join from "../GraphQL.Join/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Internal_Util from "../Internal.Util/index.js";
import * as Steps_WorkQueue_Cache from "../Steps.WorkQueue.Cache/index.js";
import * as Steps_WorkQueue_State from "../Steps.WorkQueue.State/index.js";
import * as Steps_WorkQueue_UIState from "../Steps.WorkQueue.UIState/index.js";
import * as Steps_WorkQueue_View from "../Steps.WorkQueue.View/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_Checkbox from "../Widgets.Checkbox/index.js";
import * as Widgets_HiddenSelect from "../Widgets.HiddenSelect/index.js";
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var union = /* #__PURE__ */ Data_Map_Internal.union(ordRNTY);
var map = /* #__PURE__ */ Data_Functor.map(Data_Map_Internal.functorMap);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var areFormsSelected = /* #__PURE__ */ API_FormType.areFormsSelected(Data_Functor.functorArray)(Data_Foldable.foldableArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var selectForms = /* #__PURE__ */ API_FormType.selectForms(Data_Functor.functorArray)(Data_Foldable.foldableArray);
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var map2 = /* #__PURE__ */ Data_Functor.map(Concur_Core_Types.functorWidget);
var label = /* #__PURE__ */ Concur_React_DOM.label(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var abbr = /* #__PURE__ */ Concur_React_DOM.abbr(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqInt));
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var mod = /* #__PURE__ */ Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_React_Props.functorProps);
var span = /* #__PURE__ */ Concur_React_DOM.span(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var map4 = /* #__PURE__ */ Data_Functor.map(GraphQL_Query.queryFunctor);
var notEq = /* #__PURE__ */ Data_Eq.notEq(API_Account.eqAccType);
var isEmpty = /* #__PURE__ */ Internal_SelectionMap.isEmpty(ordRNTY);
var main = /* #__PURE__ */ Concur_React_DOM.main(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var header = /* #__PURE__ */ Concur_React_DOM.header(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var h1 = /* #__PURE__ */ Concur_React_DOM.h1(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var p$prime = /* #__PURE__ */ Concur_React_DOM["p$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var map5 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff));
var runGraphQL = /* #__PURE__ */ GraphQL_Join.runGraphQL(GraphQL_Query.qgql);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff));
var State = /* #__PURE__ */ (function () {
    function State(value0) {
        this.value0 = value0;
    };
    State.create = function (value0) {
        return new State(value0);
    };
    return State;
})();
var Navigate = /* #__PURE__ */ (function () {
    function Navigate(value0) {
        this.value0 = value0;
    };
    Navigate.create = function (value0) {
        return new Navigate(value0);
    };
    return Navigate;
})();
var WorkQR = /* #__PURE__ */ (function () {
    function WorkQR(value0) {
        this.value0 = value0;
    };
    WorkQR.create = function (value0) {
        return new WorkQR(value0);
    };
    return WorkQR;
})();
var Export = /* #__PURE__ */ (function () {
    function Export() {

    };
    Export.value = new Export();
    return Export;
})();
var withForms = function (state) {
    return function (func) {
        var expandedStudents = union(state.workQueueUi.expandedStudents)(map(Data_Function["const"](Steps_WorkQueue_UIState.Expanded.value))(state.workQueueState.students.sel));
        return {
            forms: state.forms,
            workQueueCache: state.workQueueCache,
            reorder: state.reorder,
            movedDownIdx: state.movedDownIdx,
            workQueueState: {
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                semester: state.workQueueState.semester,
                teacher: state.workQueueState.teacher,
                forms: func(state.workQueueState.forms)
            },
            workQueueUi: {
                expandedForms: state.workQueueUi.expandedForms,
                search: state.workQueueUi.search,
                teacher: state.workQueueUi.teacher,
                semester: state.workQueueUi.semester,
                expandedStudents: expandedStudents
            }
        };
    };
};
var setTeacherSelect = function (state) {
    return function (teacher) {
        return {
            forms: state.forms,
            workQueueCache: state.workQueueCache,
            reorder: state.reorder,
            movedDownIdx: state.movedDownIdx,
            workQueueUi: {
                expandedStudents: state.workQueueUi.expandedStudents,
                expandedForms: state.workQueueUi.expandedForms,
                search: state.workQueueUi.search,
                semester: state.workQueueUi.semester,
                teacher: teacher
            },
            workQueueState: {
                forms: state.workQueueState.forms,
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                semester: state.workQueueState.semester,
                teacher: map1(function (v1) {
                    return v1.value;
                })(Widgets_BetterSelect.selectedItem(teacher))
            }
        };
    };
};
var setSemesterSelect = function (state) {
    return function (semester) {
        return {
            forms: state.forms,
            workQueueCache: state.workQueueCache,
            reorder: state.reorder,
            movedDownIdx: state.movedDownIdx,
            workQueueUi: {
                expandedStudents: state.workQueueUi.expandedStudents,
                expandedForms: state.workQueueUi.expandedForms,
                search: state.workQueueUi.search,
                teacher: state.workQueueUi.teacher,
                semester: semester
            },
            workQueueState: {
                forms: state.workQueueState.forms,
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                teacher: state.workQueueState.teacher,
                semester: map1(function (v1) {
                    return v1.value;
                })(Widgets_BetterSelect.selectedItem(semester))
            }
        };
    };
};
var setFormReorder = function (fps) {
    return function (reorder) {
        return {
            forms: fps.forms,
            workQueueState: fps.workQueueState,
            workQueueUi: fps.workQueueUi,
            workQueueCache: fps.workQueueCache,
            movedDownIdx: fps.movedDownIdx,
            reorder: reorder
        };
    };
};
var selectAllFormsCheckbox = function (state) {
    return bind(Widgets_Checkbox["labelCheckbox$prime"]("form-picker-select-all")("form-picker-select-all")(Translate.lookupTranslation("select-all"))(areFormsSelected(state.forms)(state.workQueueState.forms)))(function (v) {
        return pure(withForms(state)(selectForms(state.forms)(v)));
    });
};
var renderFormCheckboxes = function (state) {
    var update = function (v) {
        return function (v1) {
            if (v1) {
                return withForms(state)(API_FormType.selectForm(v));
            };
            if (!v1) {
                return withForms(state)(API_FormType.deselectForm(v));
            };
            throw new Error("Failed pattern match at Steps.FormPicker (line 158, column 9 - line 158, column 61): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
    var selectedClass = function (form) {
        var $74 = API_FormType.isFormSelected(form)(state.workQueueState.forms);
        if ($74) {
            return " selected";
        };
        return "";
    };
    var formCheckBoxRender = function (form) {
        return div([ Concur_React_Props.className("form-type" + selectedClass(form)), Concur_React_Props.key("form-type-" + (GraphQL_Type.innerId(form.id) + "-container")), Concur_React_Props["_id"]("form-type-" + (GraphQL_Type.innerId(form.id) + "-container")) ])([ map2(update(form))(Widgets_Checkbox.checkbox([ Concur_React_Props["_id"]("form-" + GraphQL_Type.innerId(form.id)), Concur_React_Props.className("form-checkbox") ])(API_FormType.isFormSelected(form)(state.workQueueState.forms))), label([ Concur_React_Props.htmlFor("form-" + GraphQL_Type.innerId(form.id)), Concur_React_Props.className("form-label") ])([ abbr([ Concur_React_Props.className("form-abbr"), Concur_React_Props.style({
            backgroundColor: form.bgColor
        }) ])([ text(form.abbr) ]), text(form.label) ]) ]);
    };
    return map3(formCheckBoxRender)(state.forms);
};
var renderFormArrows = function (state) {
    var wasMovedUp = function (v) {
        if (eq(new Data_Maybe.Just(v + 1 | 0))(state.movedDownIdx)) {
            return true;
        };
        return false;
    };
    var wasMovedDown = function (v) {
        if (eq(new Data_Maybe.Just(v))(state.movedDownIdx)) {
            return true;
        };
        return false;
    };
    var moveDown = function (idx) {
        var update = bind1(Data_Array.index(state.forms)(idx))(function ($$this) {
            return bind1(Data_Array.index(state.forms)(idx + 1 | 0))(function (after) {
                return bind1(Data_Array.updateAt(idx)(after)(state.forms))(Data_Array.updateAt(idx + 1 | 0)($$this));
            });
        });
        if (update instanceof Data_Maybe.Nothing) {
            return state;
        };
        if (update instanceof Data_Maybe.Just) {
            return {
                reorder: state.reorder,
                workQueueCache: state.workQueueCache,
                workQueueState: state.workQueueState,
                workQueueUi: state.workQueueUi,
                forms: update.value0,
                movedDownIdx: new Data_Maybe.Just(idx + 1 | 0)
            };
        };
        throw new Error("Failed pattern match at Steps.FormPicker (line 189, column 20 - line 191, column 73): " + [ update.constructor.name ]);
    };
    var formArrowRender = function (idx) {
        return function (form) {
            return div([ Concur_React_Props.className("form-type" + ((function () {
                var $79 = wasMovedDown(idx);
                if ($79) {
                    return " moved-down";
                };
                return "";
            })() + (function () {
                var $80 = wasMovedUp(idx);
                if ($80) {
                    return " moved-up-" + show(mod(idx)(2));
                };
                return "";
            })())), Concur_React_Props.key("form-type-" + (GraphQL_Type.innerId(form.id) + "-container")), Concur_React_Props["_id"]("form-type-" + (GraphQL_Type.innerId(form.id) + "-container")) ])([ div([ Concur_React_Props.className("form-arrows") ])(append1((function () {
                var $81 = idx > 0;
                if ($81) {
                    return [ button([ Concur_React_Props.className("arrow-up"), voidRight(moveDown(idx - 1 | 0))(Concur_React_Props.onClick) ])([ span([ Concur_React_Props.className("arrow-up-icon") ])([  ]), span([ Concur_React_Props.className("sr-only") ])([ text(Translate.lookupTranslation("up")) ]) ]) ];
                };
                return [ span([ Concur_React_Props.className("arrow-up-icon-first") ])([  ]) ];
            })())((function () {
                var $82 = idx < (length(state.forms) - 1 | 0);
                if ($82) {
                    return [ button([ Concur_React_Props.className("arrow-down"), voidRight(moveDown(idx))(Concur_React_Props.onClick) ])([ span([ Concur_React_Props.className("arrow-down-icon") ])([  ]), span([ Concur_React_Props.className("sr-only") ])([ text(Translate.lookupTranslation("down")) ]) ]) ];
                };
                return [ span([ Concur_React_Props.className("arrow-down-icon-last") ])([  ]) ];
            })())), label([ Concur_React_Props.className("form-label") ])([ abbr([ Concur_React_Props.className("form-abbr"), Concur_React_Props.style({
                backgroundColor: form.bgColor
            }) ])([ text(form.abbr) ]), text(form.label) ]) ]);
        };
    };
    return Data_Array.mapWithIndex(formArrowRender)(state.forms);
};
var renderFormPicker = function (state) {
    var render = (function () {
        if (state.reorder) {
            return renderFormArrows(state);
        };
        return renderFormCheckboxes(state);
    })();
    return div([ Concur_React_Props.className("form-picker") ])(Data_Array.cons(selectAllFormsCheckbox(state))(render));
};
var initFormPicker = function (workQueueState) {
    return function (workQueueUi) {
        return function (workQueueCache) {
            return function (v) {
                return {
                    workQueueState: workQueueState,
                    workQueueUi: workQueueUi,
                    workQueueCache: workQueueCache,
                    reorder: false,
                    movedDownIdx: Data_Maybe.Nothing.value,
                    forms: v
                };
            };
        };
    };
};
var loadFormPicker = function (workQueueState) {
    return function (workQueueUi) {
        return function (workQueueCache) {
            return map4(initFormPicker(workQueueState)(workQueueUi)(workQueueCache))(API_FormType.formListQuery);
        };
    };
};
var formPickerWidget = function (fps) {
    return div([ Concur_React_Props.className("form-picker-step") ])([ renderFormPicker(fps) ]);
};
var formPickerStepWidget = function (preservedQuery) {
    return function (state) {
        var notBoardAcc = notEq(state.workQueueCache.account.type)(API_Account.BoardAccount.value);
        var actionBtns = div([ Concur_React_Props.className("btn-group") ])(Data_Array.catMaybes([ new Data_Maybe.Just(button([ Concur_React_Props.className("btn cancel"), voidRight(new Navigate(App_Step.NavCancel.value))(Concur_React_Props.onClick) ])([ text(Translate.lookupTranslation("cancel")) ])), Internal_Util.justIf(!Steps_WorkQueue_State.isWorkQueueEmpty(state.workQueueState))(button([ Concur_React_Props.className("btn export"), Concur_React_Props.disabled(isEmpty(state.workQueueState.forms) || !Steps_WorkQueue_State.formForSelected(state.workQueueCache.account)(state.workQueueState)), voidRight(Export.value)(Concur_React_Props.onClick) ])([ text(Translate.lookupTranslation("export-pdf")) ])), new Data_Maybe.Just(button([ Concur_React_Props.className("btn btn-primary"), Concur_React_Props.disabled(isEmpty(state.workQueueState.forms) || !Steps_WorkQueue_State.formForSelected(state.workQueueCache.account)(state.workQueueState)), voidRight(new Navigate(App_Step.NavNext.value))(Concur_React_Props.onClick) ])([ text(Translate.lookupTranslation("next")) ])) ]));
        return main([ Concur_React_Props.className("step-container step-2b"), Concur_React_Props.role("main") ])(Data_Array.catMaybes([ new Data_Maybe.Just(header([ Concur_React_Props.className("page-header") ])([ h1([ Concur_React_Props.className("page-heading") ])([ text(Translate.lookupTranslation("select-forms")) ]), actionBtns ])), new Data_Maybe.Just(map2(WorkQR.create)(Steps_WorkQueue_View.workQueueWidgetWithRoute(preservedQuery)(state.workQueueState)(state.workQueueUi)(state.workQueueCache))), Internal_Util.justIf(!Steps_WorkQueue_State.formForSelected(state.workQueueCache.account)(state.workQueueState))(div([ Concur_React_Props.className("error") ])([ text(Translate.lookupTranslation("must-select-teacher-semester")) ])), new Data_Maybe.Just(div([ Concur_React_Props.className("teacher-semester-selections") ])(Data_Array.catMaybes([ new Data_Maybe.Just(p$prime([ text(Translate.lookupTranslation("semester-hidden-select")) ])), new Data_Maybe.Just(map2(map5(State.create)(setSemesterSelect(state)))(Widgets_HiddenSelect.hiddenSelect(state.workQueueUi.semester))), Internal_Util.justIf(notBoardAcc)(p$prime([ text(Translate.lookupTranslation("teacher-hidden-select")) ])), Internal_Util.justIf(notBoardAcc)(map2(map5(State.create)(setTeacherSelect(state)))(Widgets_HiddenSelect.hiddenSelect(state.workQueueUi.teacher))) ]))), new Data_Maybe.Just(div([ Concur_React_Props.className("step-2b-right") ])([ map2(State.create)(formPickerWidget(state)) ])) ]));
    };
};
var endFormReorder = function (fps) {
    return Control_Monad_Except_Trans.runExceptT(discard(runGraphQL(API_FormType.setFormOrder(map3(function (v) {
        return v.id;
    })(fps.forms))))(function () {
        return pure1({
            forms: fps.forms,
            movedDownIdx: fps.movedDownIdx,
            workQueueCache: fps.workQueueCache,
            workQueueState: fps.workQueueState,
            workQueueUi: fps.workQueueUi,
            reorder: false
        });
    }));
};
var emptyFormPickerState = /* #__PURE__ */ (function () {
    return {
        forms: [  ],
        reorder: false,
        movedDownIdx: Data_Maybe.Nothing.value,
        workQueueState: Steps_WorkQueue_State.initialWorkQueueState,
        workQueueUi: Steps_WorkQueue_UIState.initialWorkQueueUiState,
        workQueueCache: Steps_WorkQueue_Cache.initialWorkQueueCache
    };
})();
export {
    formPickerWidget,
    renderFormPicker,
    formPickerStepWidget,
    State,
    Navigate,
    WorkQR,
    Export,
    initFormPicker,
    loadFormPicker,
    emptyFormPickerState,
    setFormReorder,
    endFormReorder
};
//# sourceMappingURL=index.js.map
